import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsbutton',
	templateUrl:'./BSButtonPluginCompPage.html',
	styles: [],
	styleUrls:['./BSButtonPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSButtonPluginCompPage
{
	mdContent_785 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.buttons.BSButton;
\`\`\``;
	mdContent_786 = `\`\`\`java
BSButton()
\`\`\``;
	mdContent_787 = `\`\`\`java
BSButton(String text)
\`\`\``;
	mdContent_788 = `\`\`\`java
BSButton&lt;?&gt; btn = new BSButton&lt;&gt;("Submit");
btn.setPrimaryOutline(true);
btn.setSize(BSButtonSizeOptions.Lg);
\`\`\``;
}
